import React, { createContext, useContext, useState, ReactNode, useCallback } from "react";
import { routes } from "@/routes";
import { RouteName } from "../routes";
import log from "../utils/logger";

interface RouteContextType {
  currentRoute: RouteName;
  setCurrentRoute: (route: RouteName) => void;
}

const RouteContext = createContext<RouteContextType | undefined>(undefined);

export const RouteProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [currentRoute, setCurrentRoute] = useState<RouteName | undefined>();

  const setRoute = useCallback((route: RouteName) => {
    if (routes.some((r) => r.name === route)) {
      setCurrentRoute(route);
    } else {
      log.error(`Route "${route}" not found`);
    }
  }, []);

  return <RouteContext.Provider value={{ currentRoute, setCurrentRoute: setRoute }}>{children}</RouteContext.Provider>;
};

export const useRoute = () => {
  const context = useContext(RouteContext);
  if (context === undefined) {
    throw new Error("useRoute must be used within a RouteProvider");
  }
  return context;
};

export const useNavigate = () => {
  const { setCurrentRoute } = useRoute();
  return setCurrentRoute;
};
